import { EntityService } from './EntityService';
import { IEntity, IPPAppEvidence } from '../types';

export class PPAppEvidenceService extends EntityService<IPPAppEvidence> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/PPAppEvidences`);
    }

    public readAllForEvList(
        dataFor: 'Project',
        entityID: number
    ): Promise<IEntity[]> {
        const query = `?getGeneralEvidencesForList=${dataFor}&entityID=${entityID}`;
        return this.readAll(query);
    }
}